import template from './user-wallet-transactions.html';
import userWalletTransactionsController from './user-wallet-transactions.controller';
import './user-wallet-transactions.styl';

let userWalletTransactionsComponent = {
  restrict: 'E',
  bindings: {
    walletTransactions: '<'
  },
  template,
  controller: userWalletTransactionsController,
  controllerAs: 'vm'
};

export default userWalletTransactionsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-wallet-transactions/user-wallet-transactions.component.js
 **/